// extracted by mini-css-extract-plugin
export default {"cartoonEditor":"cartoonEditor___IUUK4"};